import React from 'react';
import { Image } from '@chakra-ui/react';
import { calendar } from '../../assets/new-images/icons';

const iconMap = {
  calendar: calendar,
  // phone: phoneImage,
};

const Icon = ({ icon, size = "20", ...rest }) => {
  if (typeof icon === "string" && iconMap[icon]) {
    // Se o ícone for um nome de ícone do iconMap
    return <Image src={iconMap[icon]} boxSize={size} {...rest} />;
  } else {
    // Se o ícone for um componente de ícone do react-icons
    return React.cloneElement(icon, { size, ...rest });
  }
};

export default Icon;
